import { BaseStrings } from "./base_strings";

export const Strings: BaseStrings = {
    appLongName: "Account Certificate Manager",
    appShortName: "ACM",
    brandName: "HID",
    rootCssClass: "acm",
    supportEmail: "acmsupport@hydrantid.com",
    helpDocuments: {
        html: {
            url: "https://help.hydrantid.com/",
            label: "View HID Account Certificate Manager help manual",
        },
    },
    chartColors: [
        {
            backgroundColor: "#007da5",
            borderColor: "#005f7d",
            pointBackgroundColor: "#00aed9",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#00aed9",
        },
    ],
};
